const baseUrl = "/provider-360";

export default {
  baseUrl,
  ATTRIBUTION_PANELS: `${baseUrl}/panel-management/panel-attribution`,
  ATTRIBUTION_ASSIGNMENT_OPERATIONS: `${baseUrl}/panel-management/assignment-operations`,
  ATTRIBUTION_CAPACITY_OPERATIONS: `${baseUrl}/panel-management/capacity-operations`,
  PROVIDER_DIRECTORY_ORGANIZATIONS: `${baseUrl}/configuration/organizations`,
  PROVIDER_DIRECTORY_COMPANIES: `${baseUrl}/configuration/companies`,
  PROVIDER_DIRECTORY_FACILITIES: `${baseUrl}/provider-directory/facilities`,
  PROVIDER_DIRECTORY_MY_PROFILE: `${baseUrl}/provider-directory/my-profile`,
  PROVIDER_DIRECTORY_PROVIDERS: `${baseUrl}/provider-directory/providers`,
  PROVIDER_DIRECTORY_CARE_TEAMS: `${baseUrl}/provider-directory/care-teams`,
  PROVIDER_DIRECTORY_HEALTH_PLANS: `${baseUrl}/configuration/health-plans`,
  INSIGHTS_ATTRIBUTION: `${baseUrl}/insights/attribution`,
  INSIGHTS_ATTRIBUTION_CAPACITY_ANALYSIS: `${baseUrl}/insights/attribution/capacity-analysis`,
  CONFIGURATION_DIRECTORY_OPTIONS: `${baseUrl}/configuration/directory-options`,
  CONFIGURATION_ACTIVITY_STREAM: `${baseUrl}/configuration/activity-stream`,
};
